<template>
<div>
    <!-- <h2>邀请函</h2>
    <h3>(长按图片保存)</h3>
    <img src="//xgzx.admin.talkmed.com/image/buttons/盖章版-全国并发症论坛-招商函-0505-1500_00.png">
    <img src="//xgzx.admin.talkmed.com/image/buttons/盖章版-全国并发症论坛-招商函-0505-1500_01.png"/>
    <img src="//xgzx.admin.talkmed.com/image/buttons/盖章版-全国并发症论坛-招商函-0505-1500_02.png"/>
    <img src="//xgzx.admin.talkmed.com/image/buttons/盖章版-全国并发症论坛-招商函-0505-1500_03.png"/>
    <img src="//xgzx.admin.talkmed.com/image/buttons/盖章版-全国并发症论坛-招商函-0505-1500_04.png"/>
    <img src="//xgzx.admin.talkmed.com/image/buttons/盖章版-全国并发症论坛-招商函-0505-1500_05.png"/>
    <img src="//xgzx.admin.talkmed.com/image/buttons/盖章版-全国并发症论坛-招商函-0505-1500_06.png"/>
    <img src="//xgzx.admin.talkmed.com/image/buttons/盖章版-全国并发症论坛-招商函-0505-1500_07.png"/>
    <img src="//xgzx.admin.talkmed.com/image/buttons/盖章版-全国并发症论坛-招商函-0505-1500_08.png"/>
    <img src="//xgzx.admin.talkmed.com/image/buttons/盖章版-全国并发症论坛-招商函-0505-1500_09.png"/> -->
    <div class="ppts max-content">
        <div class="item">
		    <img :src="info.banner"/>
            <span class="name">{{info.name}}</span>
			<div style="margin-top:5px;" v-if="info.bind_url">
				<van-button :url="info.bind_url" icon="down" color="#d2020d" size="small" style="margin-right:20px">下载</van-button>
				<van-button icon="envelop-o"  size="small" plain color="#d2020d" @click="inputEmail(info.bind_url)">发送到邮箱</van-button>
			</div>

        </div>
		<van-overlay :show="show" @click="show = false">
            <div class="wrapper" >
                <div class="block" @click.stop>
                    <van-field v-model="email" label="邮箱" placeholder="我们将发送邀请函至您填写的邮箱" label-width="50px"></van-field>
                    <van-button round @click="sendPdf">确定发送</van-button>
                </div>
            </div>
        </van-overlay>
	</div>
</div>
</template>

<script>
import { ButtonDetail,sendPPTEmail,ArticlesDetails} from '../../config/interface.js'
export default {
    data(){
        return{
            meeting_id:this.$route.query.meeting_id?this.$route.query.meeting_id:this.$route.query.MT_id,
            button_id:this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id,
            id:this.$route.query.id,
            show:false,
            email:localStorage.getItem('email')?localStorage.getItem('email'):'',
            send_url:'',
            info:{}
        }
    },
    created(){
        this.button_id=this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id;
        this.getButtonData();
        if(this.id){
            this.getDetail();
        }
    },
    methods:{
        //获取按钮信息
        getButtonData(){
            if(this.button_id){
                const url=ButtonDetail;
                let params={
                    button_id:this.button_id
                }
                const method="POST";
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        document.title=res.data.share_title;
                        if(common.is_weixin()){
                            let data=res.data;
                            common.wxShare(data.share_title,data.share_sub_title,data.share_img);
                        }
                    }
                })

            }
        },
        goTo(url){
            window.location.href=url;
        },
        inputEmail(url){
            this.show=true;
            this.send_url=url;
        },
        sendPdf(){
            if(this.checkEmail(this.email)){
                const url=sendPPTEmail;
                const method='POST';
                localStorage.setItem('email',this.email);
                let params={
                    ppt_url:this.send_url,
                    email:this.email,
                    type:'pdf模板'

                };
                fetch(url,params,method)
                    .then((res)=>{
                    if(res.code==0){
                        common.toast("发送成功", 1000, "success", () => {
                            this.show=false;
                        });
                    }
                    else{
                            common.toast( res && res.error_msg ? res.error_msg : "未知错误",1000,'fail',()=>{
                        })
                    }
            })

            }

        },
        checkEmail(val){
            // let reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
            if(val === ""){ //输入不能为空
                common.toast('请您填写邮箱',1000)
                return false;
            }else{
                return true;
            }
        },
        getDetail(){
            const url=ArticlesDetails;
            let params={
                article_id:this.id
            }
            const method="POST";
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    this.info=res.data
                }
            })
        }
    }
}
</script>

<style scoped>
h2{
    text-align: center;
    line-height: 30px;
    margin-top: 20px;
}
h3{
    text-align: center;
    line-height: 30px;
    margin-bottom: 10px;

}
img{
    width: 100%;
    display: block;
}
</style>
<style lang="scss" scoped>
		.ppts{
        margin:15px;
        .item{
            margin-bottom:20px;
            img{
                width: 100%;
            }
            .name{
                font-size:18px;
                line-height: 36px;
            }

        }
    }
	.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 90%;
    height: 120px;
    background-color: #fff;
    padding: 10px;
    text-align: center;
    p{
        font-size:14px ;
    }
    .van-field{
        border-width:1px;
    }
    .van-button{
        text-align: center;
        background: $color-main;
        color: white;
        margin-top:10px ;
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/XVC/invite.vue